@if (type === 'new') {
  <h2 class="mb-4" i18n="Create tenant label">
  {{ "create" | transloco }} {{ "contact" | transloco }}
</h2>
}
@if (type !== 'new') {
  <h2 class="mb-4" i18n="Edit tenant label">
  {{ "edit" | transloco }} {{ "contact" | transloco }}
</h2>
}
@if (type === 'new' || contact) {
  <div class="row mb-4">
    <div class="col-12">
      <app-contacts-editform
        [editedContact]="contact"
        (ContactSubmit)="createContact($event)"
      ></app-contacts-editform>
      @if (repo.isLoading$ | async) {
        <h2><app-spinner></app-spinner></h2>
      }
      <app-error-alert
        title="Could not submit the contact profile"
        [errors]="submitErrors"
      ></app-error-alert>
    </div>
  </div>
}
<!--<div>
<app-error-alert *ngIf="type !== 'new' && !(contact) " title="Could not submit the contact profile"
[errors]="['Contact is null']"></app-error-alert>
</div>-->
